// This Component displays a list of items
// A show list Item and a h2 title

import { useTranslation } from "react-i18next";
import ArticleItem from "./ArticleItem";
import { Col, Container, Row } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import { ImNeutral } from "react-icons/im";

function ArticleListShowcase({ articles, isLoading }) {
  const { t } = useTranslation();

  return (
    <Container className="u-mt-medium">
      <Row>
        {isLoading ? (
          <Spinner animation="grow" variant="primary" />
        ) : articles ? (
          articles.map((article) => (
            <Col key={article.slug} md={6} lg={3}>
              <ArticleItem
                name={article.title}
                description={article.description}
                slug={article.slug}
                image={article.image}
                date={article.modified}
              />
            </Col>
          ))
        ) : (
          <>
            <h3>{t("blog_page_no_artcle_available_text")}</h3>
            <ImNeutral size={25} />
          </>
        )}
      </Row>
    </Container>
  );
}

export default ArticleListShowcase;
